import React from 'react';
import { ThemeProvider, CssBaseline, Box, Typography, Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/pro-light-svg-icons';
import { faDoNotEnter } from '@fortawesome/pro-duotone-svg-icons';
export var NoAccess = function (_a) {
    var theme = _a.theme, displayName = _a.displayName;
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(CssBaseline, null),
        React.createElement(Box, { mt: '200px', textAlign: 'center' },
            React.createElement(Typography, { variant: 'h2', align: 'center', color: 'error' },
                React.createElement(FontAwesomeIcon, { icon: faDoNotEnter }),
                "Access is Denied"),
            React.createElement(Typography, null,
                "Your user account does not have access to ",
                displayName,
                ". Please contact the helpdesk for assistance."),
            React.createElement(Box, { mt: '25px' },
                React.createElement(Button, { href: window.location.origin, variant: 'outlined', size: 'small' },
                    React.createElement(FontAwesomeIcon, { icon: faUndo, style: { marginRight: '8px' } }),
                    " Retry")))));
};
//# sourceMappingURL=no-access.js.map